import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconSeaFreight = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9831 18.9584H8.0164C4.8664 18.9584 2.39139 16.9751 1.70806 13.9001L1.36641 12.3501C1.13308 11.2834 1.74139 10.1334 2.74972 9.72507L8.52474 7.40841C9.47474 7.03341 10.5247 7.03341 11.4747 7.40841L17.2497 9.72507C18.2664 10.1334 18.8747 11.2834 18.6331 12.3501L18.2914 13.9001C17.6081 16.9751 15.1331 18.9584 11.9831 18.9584ZM9.99973 8.37505C9.65807 8.37505 9.3164 8.44173 8.98307 8.56673L3.20807 10.8834C2.7664 11.0584 2.47473 11.6167 2.57473 12.0751L2.9164 13.6251C3.47473 16.1417 5.42472 17.7001 8.00805 17.7001H11.9747C14.5581 17.7001 16.5081 16.1417 17.0664 13.6251L17.4081 12.0751C17.5081 11.6167 17.2164 11.0584 16.7747 10.8834L10.9997 8.56673C10.6831 8.44173 10.3414 8.37505 9.99973 8.37505Z"
          fill={color}
        />
        <path
          d="M9.99992 18.9584C9.65825 18.9584 9.37492 18.6751 9.37492 18.3334V8.33342C9.37492 7.99175 9.65825 7.70842 9.99992 7.70842C10.3416 7.70842 10.6249 7.99175 10.6249 8.33342V18.3334C10.6249 18.6751 10.3416 18.9584 9.99992 18.9584Z"
          fill={color}
        />
        <path
          d="M15.8335 10.4584C15.7585 10.4584 15.6751 10.4417 15.6001 10.4167L11.0084 8.57509C10.3584 8.31676 9.64179 8.31676 8.98345 8.57509L4.39178 10.4167C4.20011 10.4917 3.98346 10.4668 3.80846 10.3501C3.63346 10.2334 3.53345 10.0417 3.53345 9.8334V6.66675C3.53345 4.94175 4.93345 3.54175 6.65845 3.54175H13.3251C15.0501 3.54175 16.4501 4.94175 16.4501 6.66675V9.8334C16.4501 10.0417 16.3501 10.2334 16.1751 10.3501C16.0751 10.4251 15.9585 10.4584 15.8335 10.4584ZM10.0001 7.12507C10.5001 7.12507 10.9997 7.21674 11.4747 7.40841L15.2085 8.90842V6.66675C15.2085 5.63341 14.3668 4.79175 13.3335 4.79175H6.66679C5.63345 4.79175 4.79179 5.63341 4.79179 6.66675V8.90842L8.52474 7.40841C8.99974 7.22507 9.50012 7.12507 10.0001 7.12507Z"
          fill={color}
        />
        <path
          d="M12.0833 4.79175H7.91658C7.57492 4.79175 7.29158 4.50841 7.29158 4.16675V2.50008C7.29158 1.70008 7.94992 1.04175 8.74992 1.04175H11.2499C12.0499 1.04175 12.7083 1.70008 12.7083 2.50008V4.16675C12.7083 4.50841 12.4249 4.79175 12.0833 4.79175ZM8.54158 3.54175H11.4583V2.50008C11.4583 2.38341 11.3666 2.29175 11.2499 2.29175H8.74992C8.63325 2.29175 8.54158 2.38341 8.54158 2.50008V3.54175Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
